<template>
  <section class="view">
    <transition
      v-if="showView && !isAuthView"
      name="transition--header"
      mode="out-in"
      :appear="fromRoute !== false && fromRoute.meta.group === 'auth' ? true : false"
    >
      <AppHeader />
    </transition>

    <!-- TODO: Almost works...
        v-closable="{
          exclude: ['xxx'],
          handler: 'closeNotification'
        }"
    -->
    <div
      v-if="isAuthenticated && addingNotification === true"
      class="overlay"
    >
      <UtilityNotification
        key="NOTIFICATION__CREATE"
        mode="create"
        @closed="closeNotification()"
        @submitted="closeNotification()"
      />
    </div>

    <div
      v-if="overlayMask"
      class="view--mask"
    />

    <transition
      v-if="showView"
      :name="transitionName"
      mode="out-in"
      :appear="true"
    >
      <router-view
        :key="transitionKey"
        :class="[overlayMask ? 'view--opaque' : '', 'TRANSITION_NAME: ' + transitionName, 'TRANSITION_KEY: ' + transitionKey]"
      />
    </transition>

    <AppFooter v-if="showView && !isAuthView" />
  </section>
</template>

<script>
import AppHeader from '@/components/app/Header.vue'
import AppFooter from '@/components/app/Footer.vue'
import UtilityNotification from '@/components/utility/Notification.vue'
import helperMethods from '@/helpers/utility'
import config from '@/helpers/config'

export default {
  components: {
    AppHeader,
    AppFooter,
    UtilityNotification
  },
  data () {
    return {
      showView: false,
      toRoute: false,
      fromRoute: false,
      transitionKey: false,
      transitionName: false
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    selectingFilter () {
      return this.$store.getters['search/getSelectingFilter']
    },
    addingNotification () {
      return this.$store.getters['search/getAddingNotification']
    },
    overlayMask () {
      if (this.selectingFilter || this.addingNotification) {
        return true
      }

      return false
    },
    isAuthView () {
      if (this.$route.meta.group === 'auth') {
        return true
      }

      return false
    }
  },
  methods: {
    closeNotification () {
      this.$store.dispatch('search/setAddingNotification', false)
    },
    getTransition (type) {
      let key = 'VIEW__A'
      let name = ''
      let uniq = 'A'
      key = 'VIEW__' + uniq

      if (this.toRoute && this.toRoute.query) {
        let filtersString = ''

        if (this.toRoute.params && this.toRoute.params.id) {
          filtersString = 'id=' + this.toRoute.params.id + '&'
        }

        for (const [key, value] of Object.entries(this.toRoute.query)) {
          if (config.validFilters.includes(key)) {
            filtersString = filtersString + key + '=' + value + '&'
          }
        }

        uniq = this.generateSearchToken(filtersString)
        key = 'VIEW__' + this.toRoute.name + uniq
      }

      // Auth transitions
      if (this.fromRoute !== false && this.fromRoute.meta.group === 'auth' && this.toRoute.meta.group !== 'auth') {
        name = 'transition--fromAuth'
      } else if (this.toRoute !== false && this.toRoute.meta.group === 'auth' && this.fromRoute.meta.group !== 'auth') {
        name = 'transition--toAuth'
      }

      // Retransitioning when starting new search
      else if (['Search', 'Datasets', 'PDFs', 'News'].includes(this.toRoute.name) && this.fromRoute.name === this.toRoute.name && (this.fromRoute.query && this.toRoute.query && this.fromRoute.query.page === this.toRoute.query.page)) {
        name = 'transition--toDown'
      }

      // Resource transitions
      else if (['Dataset', 'PDF'].includes(this.toRoute.name)) {
        name = 'transition--toDown'
      } else if (['Dataset', 'PDF'].includes(this.fromRoute.name)) {
        name = 'transition--toUp'
      }

      // Navigation transitions
      else if (['Search'].includes(this.toRoute.name)) {
        name = 'transition--toLeft'
      } else if (['Datasets'].includes(this.toRoute.name) && ['Datasets'].includes(this.fromRoute.name) === false) {
        name = ['Search'].includes(this.fromRoute.name) ? 'transition--toRight' : 'transition--toLeft'
      } else if (['PDFs'].includes(this.toRoute.name) && ['PDFs'].includes(this.fromRoute.name) === false) {
        name = ['Search', 'Datasets'].includes(this.fromRoute.name) ? 'transition--toRight' : 'transition--toLeft'
      } else if (['News'].includes(this.toRoute.name) && ['News'].includes(this.fromRoute.name) === false) {
        name = ['Search', 'Datasets', 'PDFs'].includes(this.fromRoute.name) ? 'transition--toRight' : 'transition--toLeft'
      }

      return type === 'key' ? key : name
    },
    ...helperMethods
  },
  mounted () {
    this.toRoute = this.$route
    this.fromRoute = this.$route
    this.transitionKey = this.getTransition('key')
    this.transitionName = this.getTransition('name')
    this.showView = true
  },
  watch: {
    $route (to, from) {
      this.toRoute = to
      this.fromRoute = from
      this.transitionKey = this.getTransition('key')
      this.transitionName = this.getTransition('name')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.view {
  &--mask {
    position: fixed;
    z-index: 99;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-color: rgba($black, 0.75);
  }

  &--opaque {
    opacity: 0.25;
  }
}

.overlay {
  position: fixed;
  z-index: 999;
  top: 40px;
  left: 0px;
  width: 100%;
  height: auto;

  @media screen and (min-width: $breakpointSm) {
    top: 100px;
    left: calc(50% - 225px);
    width: 450px;
  }

  @media screen and (min-width: $breakpointLg) {
    top: 108px;
  }
}

.transition {
  &--header {
    &-enter {
      transform: translateY(-100px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.6s ease-in, transform 0.6s ease-out;
    }

    &-leave-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-to {
      transform: translateY(-100px);
      opacity: 0;
    }
  }

  &--toLeft {
    &-enter {
      transform: translateX(-25px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateX(100px);
      opacity: 0;
    }
  }

  &--toRight {
    &-enter {
      transform: translateX(25px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateX(-100px);
      opacity: 0;
    }
  }

  &--toUp {
    &-enter {
      transform: translateY(15px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateY(-75px);
      opacity: 0;
    }
  }

  &--toDown {
    &-enter {
      transform: translateY(-15px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateY(75px);
      opacity: 0;
    }
  }

  &--toAuth {
    &-enter {
      transform: translateY(-100px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-in, transform 0.3s ease-out;
    }

    &-leave-active {
      transition: opacity 0.4s ease-in, transform 0.4s ease-in;
    }

    &-leave-to {
      transform: translateY(-175px);
      opacity: 0;
    }
  }

  &--fromAuth {
    &-enter {
      transform: translateY(25px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-in, transform 0.3s ease-out;
    }

    &-leave-active {
      transition: opacity 0.4s ease-in, transform 0.4s ease-in;
    }

    &-leave-to {
      transform: translateY(-100px);
      opacity: 0;
    }
  }
}

</style>
